import { CompanyLifecycle } from '@/gen/inventory/v1/company_lifecycle_pb'

export const USER_VISIBLE_COMPANY_LIFECYCLES = [
  CompanyLifecycle.OFFBOARDED,
  CompanyLifecycle.ARCHIVED,
  CompanyLifecycle.ONBOARDED,
  CompanyLifecycle.IN_EVALUATION,
  CompanyLifecycle.UNSANCTIONED,
]

export const INACTIVE_COMPANY_LIFECYLES = [CompanyLifecycle.OFFBOARDED, CompanyLifecycle.ARCHIVED]

export const ACTIVE_COMPANY_LIFECYLES = [
  CompanyLifecycle.IN_EVALUATION,
  CompanyLifecycle.ONBOARDED,
  CompanyLifecycle.UNSANCTIONED,
]

export const UNSANCTIONED_COMPANY_LIFECYLES = [CompanyLifecycle.UNSANCTIONED]
